import Vue from 'vue'
import Router from 'vue-router'
import Api from '../config'
const bgcF = '#fff';
const bgcF5 = '#f5f5f5';

const userCenter = () =>
  import ("@/pages/user_center")
const Login = () =>
  import ("@/pages/code_login")
const VipCard = () =>
  import ("@/pages/vip_card")
const CardInfo = () => 
  import ("@/pages/card_info")
const BindCard = () =>
  import ("@/pages/bind_card")
const CouponsList = () => 
  import ("@/pages/coupons_list")
const Order = () =>
  import ("@/pages/order_list")
const CardDetail = () =>
  import ("@/pages/card_detail")
const BarCode = () =>
  import ("@/pages/bar_code")
const UserInfo = () =>
  import ("@/pages/user_info")
const MyIntegral = () =>
  import ("@/pages/my_integral")
const IntegralExchange = () =>
  import ("@/pages/integral_exchange")
const IntegralBill = () =>
  import ("@/pages/integral_bill")
const IntegralDetail = () =>
  import ("@/pages/integral_detail")
const forgetPwd = () =>
  import ("@/pages/forget_pwd")
const pwdLogin = () =>
  import ("@/pages/pwd_login")
const Registered = () =>
  import ("@/pages/registered")
const userNote = () =>
  import ("@/pages/user_notes")
// const getLocation = () =>
//   import ('@/pages/getLocation')


Vue.use(Router)

export default new Router({
  mode:'history',
  base:Api.base,
  routes: [
    {
      path: '/userCenter',
      name: 'userCenter',
      component: userCenter,
      meta: {
        bgc: bgcF,
        pageType:'1'
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        bgc: bgcF,
        pageType:'1'
      }
    },
    {
      path: '/VipCard',
      name: 'VipCard',
      component: VipCard,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/CardInfo',
      name: 'CardInfo',
      component: CardInfo
    },
    {
      path: '/BindCard',
      name: 'BindCard',
      component: BindCard,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/CouponsList',
      name: 'CouponsList',
      component: CouponsList,
      meta: {
        bgc: bgcF,
        index:'0',
        keepAlive:true
      }
    },
    {
      path: '/Order',
      name: 'Order',
      component: Order,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/CardDetail',
      name: 'CardDetail',
      component: CardDetail,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/BarCode',
      name: 'BarCode',
      component: BarCode,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/UserInfo',
      name: 'UserInfo',
      component: UserInfo
    },
    {
      path: '/MyIntegral',
      name: 'MyIntegral',
      component: MyIntegral,
      meta: {
        bgc: bgcF5,
        keepAlive:true
      }
    },
    {
      path: '/IntegralExchange',
      name: 'IntegralExchange',
      component: IntegralExchange,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/IntegralBill',
      name: 'IntegralBill',
      component: IntegralBill,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/IntegralDetail',
      name: 'IntegralDetail',
      component: IntegralDetail,
      meta: {
        bgc: bgcF5
      }
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      component: forgetPwd,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/pwdLogin',
      name: 'pwdLogin',
      component: pwdLogin,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/Registered',
      name: 'Registered',
      component: Registered,
      meta: {
        bgc: bgcF
      }
    },
    {
      path: '/userNote',
      name: 'userNote',
      component: userNote,
      meta: {
        bgc: bgcF
      }
    },
    // {
    //   path: '/getLocation',
    //   name: 'getLocation',
    //   component: getLocation,
    //   meta: {
    //     bgc: bgcF
    //   }
    // },
    
    {
      path: '*',
      redirect: '/userCenter'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js